import React from 'react';
import {compose} from "recompose";
import {withAuthorization} from "../Session";
import {isAdmin} from "../../constants";
import {
    Box,
    Paper,
    Tab,
    Tabs,
    withStyles
} from "@material-ui/core";
import {appStyles} from "../../styles";
import TaskConfigurationPanel from "./TaskConfigurationPanel";
import SortieDefaultsSettings from "./SortieDefaultsTab";
import SortieEventsSettings from "./SortieEventsTab";
import TailNumbersSettings from "./TailNumbersTab";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const SettingsPage = (props) => {
    const {classes} = props;
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Paper className={classes.paper}>
            <h1 className={classes.userContainer}>Flight Options</h1>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label="Sortie Defaults" />
                <Tab label="Sortie Events" />
                <Tab label="Tail Numbers" />
                <Tab label="Sortie Tasks" />
            </Tabs>
            <TabPanel value={value} index={0}>
                <SortieDefaultsSettings {...props}/>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <SortieEventsSettings {...props}/>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <TailNumbersSettings {...props}/>
            </TabPanel>
            <TabPanel value={value} index={3}>
                <TaskConfigurationPanel {...props}/>
            </TabPanel>
        </Paper>
    );
};

export default compose(
    withAuthorization(isAdmin),
    withStyles(appStyles)
)(SettingsPage);